<template>
  <div class="menu_add">
    <el-dialog
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      center
      :title="formData.id ? '编辑化学品' : '新增化学品' "
      :visible.sync="dialogVisible"
      width="756px"
      custom-class="addoredit"
      @close="close"
    >
      <el-form ref="formDataRef" :model="formData" label-width="120px">
        <el-row>
          <el-col :span="12">
            <el-form-item
              label="所属类型:"
              prop="parentId"
              :rules="[{ required: !formData.id, message: '请选择所属类型' }]"
            >
              <el-cascader
                v-model="formData.parentId"
                :disabled="formData.id"
                :options="treeData"
                :props="defaultProps"
                filterable
                clearable
              />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              label="化学品名称:"
              prop="mc"
              :rules="[{ required: true, message: '请输入化学品名称' }]"
            >
              <el-input v-model="formData.mc" placeholder="请输入化学品名称" maxlength="200" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item
              label="化学品编码:"
              prop="bm"
              :rules="[{ required: !formData.id, message: '请输入化学品编码' }]"
            >
              <el-input v-model="formData.bm" :disabled="formData.id" placeholder="请输入化学品编码" maxlength="200" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              label="化学品单位:"
              prop="dw"
              style="width: 100%"
            >
              <el-select v-model="formData.dw" :disabled="formData.id" placeholder="请选择化学品单位">
                <el-option v-for="(item, i) in hxpUnits" :key="i" :label="item.label" :value="item.value" />
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button
          type="primary"
          :loading="loading"
          @click="sureDelete"
        >确 认</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { addHXP, updateHXP, getHXPUnit } from '@/assets/js/hxpgl'
export default {
  components: {},
  props: {
    tree: {
      type: Array,
      default() {
        return []
      }
    }
  },
  data() {
    return {
      loading: false,
      defaultProps: {
        emitPath: false,
        checkStrictly: true,
        value: 'id',
        children: 'children',
        label: 'mc'
      },
      types: [
        {
          label: '超级管理员的路由',
          value: 0
        }, {
          label: '菜单路由',
          value: 1
        }, {
          label: '路由接口',
          value: 2
        }, {
          label: '接口级限制',
          value: 3
        }
      ],
      hxpUnits: [],
      dialogVisible: false,
      formData: {
        parentId: '', // 上级化学品ID
        areaCode: '', // 化学品编码
        areaName: '', // 化学品名称
        orderNum: 0, // 显示顺序
        anotherName: '', // 别名
        shortName: '' // 简称
      }
    }
  },
  computed: {
    treeData() {
      const data = this.buildFilterTree(this.tree, (b) => {
        return b.id !== this.formData.id
      })
      return data
    }
  },
  created() { },
  mounted() {
    this.loadDicts()
  },
  beforeDestroy() { },
  methods: {
    loadDicts() {
      getHXPUnit().then(res => {
        if (res.status === 200 && res.data.code === '000000') {
          this.hxpUnits = res.data.data
        }
      })
    },
    buildFilterTree(arr, fun) {
      const data = arr.filter(fun).map((item) => {
        item = Object.assign({}, item)
        if (item.children) {
          // 递归循环
          item.children = this.buildFilterTree(item.children, fun)
        }
        if (item.children && item.children.length === 0) {
          delete item.children
        }
        if (item.level < 2 || item.level > 3) {
          item.disabled = true
        }
        return item
      }).sort((a, b) => {
        return (a.sort || 0) - (b.sort || 0)
      })
      return data
    },
    close() {
      this.$refs.formDataRef.clearValidate()
      this.$nextTick(() => {
        this.formData = {}
        this.dialogVisible = false
      })
    },
    show(row) {
      this.dialogVisible = true
      this.formData = Object.assign({}, row)
      this.$nextTick(() => {
        this.$refs.formDataRef.clearValidate()
      })
    },
    sureDelete() {
      this.$refs.formDataRef.validate((valid) => {
        if (valid) {
          this.loading = true
          if (this.formData.parentId === this.formData.resourceId) {
            this.$message({
              type: 'warning',
              message: '父菜单不能选择自己'
            })
            this.loading = false
            return
          }
          const params = Object.assign({}, this.formData)
          let API = addHXP
          if (this.formData.id) {
            API = updateHXP
          }
          API(params).then(res => {
            if (res.status === 200 && res.data.code === '000000') {
              this.$message({
                type: 'success',
                message: '保存成功'
              })
              this.close()
              this.$emit('refresh')
            }
            this.loading = false
          }).catch(() => {
            this.loading = false
          })
        }
      })
    }
  }
}
</script>
<style scoped lang="less">
.menu_add {
  // background-color: white;
  background-color: #eef1f9;
  padding: 15px;
  .title {
    background-color: white;
    width: 100%;
    height: 50px;
    margin-bottom: 15px;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  /deep/.el-dialog__body {
    margin: 20px 0;
    padding: 0 60px;
  }
  /deep/.el-radio__input.is-checked .el-radio__inner {
    border-color: none;
    background: url("../../assets/img/radiobox_down.png");
    background-size: 100% 100%;
  }
  /deep/.el-radio__input .el-radio__inner {
    border-color: none;
    background: url("../../assets/img/radiobox.png");
    background-size: 100% 100%;
    border-radius: 0;
    border: none;
  }
  /deep/.el-radio__input.is-checked .el-radio__inner::after {
    content: "";
    background: none;
  }
}
</style>
